/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: MainClass.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
 
namespace Game {
    import BSGameComponentFactory = Game.BSGameComponentFactory;
    /**
    * MainClass Custom class created.
    * @author <a href=mailto:snethani@gauselmann.com>Sujata Nethani</a>
    * @version $Revision: 1.0 $ $Date:  3 July 2020 $
    */
    /**
     * Represents the MainEntry point for the game
     * Fort most games its enough to overwrite the createGameComponentFactory
     * and use the factory to create all your custom game states
     */
    export class MainClass extends AdpGame{
        protected createGameComponentFactory():GameComponentFactory {
            return new BSGameComponentFactory();
        }
    }
}
